import styled from 'styled-components';

export const PageLayoutWrapper = styled.div``;
